document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.fc-wrapper');
  const progress = document.querySelector('.fc-progress');
  if (!wrapper || !progress) return;

  wrapper.addEventListener('scroll', () => {
    const scrollLeft = wrapper.scrollLeft;
    const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
    const percent = (scrollLeft / maxScroll) * 100;
    progress.style.transform = `translateX(${percent}%)`;
  });
});
